import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ConceptModel } from './concept.model';
import { ConceptService } from './concept.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ConceptDialogDeleteComponent } from './concept-dialog-delete.component';
import { ConceptConst } from '../const';
import { DummyComponent } from '../../../shared/dummy.component';
import * as FileSaver from 'file-saver';
import { Utils } from '../../../shared/utils';
import { ConceptComponent } from './concept.component';
import { ConceptImportComponent } from './concept-import.component';
import { consts } from '../../../consts';
import { ConceptSerialNumberComponent } from './serialNumber/concept-serialNumber.component';
import { TableService } from '../../../shared/components/table/table.service';
import { Subscription } from 'rxjs';
import { FilesService } from '../../file/files.service';
import { ConceptDialogSalesComponent } from './concept-dialog-sales.component';
import { BookingConceptSyncDialogComponent } from './booking-concept-sync-dialog.component';

@Component({
    selector: 'convfact-concept-list',
    templateUrl: './concept-list.component.html',
    styleUrls: ['./concept.component.css'],
    standalone: false
})
export class ConceptListComponent implements OnInit, OnDestroy {

  public dataSource: ConceptModel[] = [];

  public empty = false;
  public ready = false;
  public exportStatus = false;
  public all: string[] = [];

  public headerTable: any[] = ConceptConst.headerTable;

  filterView: any;
  filter: string = '';

  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  totalCostValue: string = "0";
  totalSalesValue: string = "0";
  readyValue: boolean = false;

  private subscription: Subscription;

  constructor(
    private router: Router,
    private conceptService: ConceptService,
    private fileService: FilesService,
    public dialog: MatDialog,
    private dummy: DummyComponent,
    protected snackBar: MatSnackBar,
    private tableService: TableService,
  ) { }

  ngOnInit(): void {
    this.getList();

    this.conceptService.getList().then(res => {
      let tempTotalCostValue = 0;
      let tempTotalSalesValue = 0;
      res.forEach(concept => {
        tempTotalCostValue += Utils.GetValueWithDecimals(concept.units * concept.costPrice);
        tempTotalSalesValue += Utils.GetValueWithDecimals(concept.units * concept.netPrice);
      });
      this.totalCostValue = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(tempTotalCostValue);
      this.totalSalesValue = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(tempTotalSalesValue);
      this.readyValue = true;
    });

    this.subscription = this.tableService.onGetFilter().subscribe(value => {
      this.filter = value;
      this.getList()
    });
  }

  sales() {
    this.dialog.open(ConceptDialogSalesComponent, {
      height: '40%',
      width: '40%',
    }).afterClosed().subscribe(result => {
      if (result) {
        this.conceptService.getSalesReport(result.desde, result.hasta).then(response => {
          FileSaver.saveAs(response, Utils.GetExcelName("InformeVentas"));
        }).catch(error => {
          this.displayInfo("No se han encontrado ventas en el periodo seleccionado.");
        });

      }
    });
  }

  getList() {
    this.conceptService.getSummary(this.currentPage, this.itemsPerPage, this.filterView).then(res => {
      this.tableService.set(res.values);
      this.dataSource = res.values;
      this.totalItems = res.total;

      if (this.dataSource.length === 0) {
        this.empty = true;
      } else {
        this.empty = false;
      }
      this.ready = true;
    });
  }

  pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  onSearch(filter: any) {
    this.filterView = filter;
    this.getList();
  }

  downloadFile(fileId: number) {
    this.fileService.returnFileTPV(fileId).then(response => {
      window.open(response, '_blank');
    })
  }

  //Interacción con la tabla
  onNameConceptClick(concept) {
    this.edit(concept.uid);
  }

  onUnitsEnter(concept: ConceptModel) {
    this.conceptService.editData(concept.uid, concept).then(response => {
      this.displayInfo("Unidades de " + concept.name + " , actualizadas a " + concept.units);
    }).catch(error => this.displayInfo(error.error.message));
  }
  //-------------------------

  public export() {
    this.exportStatus = true;
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      this.exportStatus = false;
      return;
    }

    this.dataSource.forEach(concept => this.all.push(concept.uid))

    this.conceptService.export(this.all).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Conceptos"));
      this.exportStatus = false;
    });
  }

  public syncBookcit(conceptUid: string): void {
    const concept = this.dataSource.find(c => c.uid === conceptUid);
    this.dialog.open(BookingConceptSyncDialogComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { conceptUid, conceptName: concept ? concept.name : '' }
    });
  }

  public create(uid: string): void {
    uid = null;
    this.dialog.open(ConceptComponent, {
      width: '60%',
      height: '70%',
      data: { uid: uid }
    });
  }

  public edit(uid: string): void {
    this.dialog.open(ConceptComponent, {
      width: '60%',
      height: '70%',
      data: { uid: uid }
    });
  }

  public delete(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.dialog.open(ConceptDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url);
      });
  }

  public serialNumber(uid: string) {
    let concept = new ConceptModel();
    this.conceptService.loadData(uid).then(response => {
      concept = response;
      if (concept.serialNumber === false) {
        this.displayInfo("El concepto " + concept.name + " no tiene número de serie/talla/modelo asignado.");
      } else {
        this.dialog.open(ConceptSerialNumberComponent, {
          width: '640px',
          maxWidth: '96vw',
          height: '70%',
          data: {
            concept: concept,
            live: false
          }
        });
      }
    });
  }

  public import() {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(ConceptImportComponent, {
      width: '760px',
      maxWidth: '96vw',
      maxHeight: '90vh',
    }).afterClosed().subscribe(imported => {
      if (imported) this.getList();
    });
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 6500;
    this.snackBar.open(message, '', options);
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

}
